import "./_account-address.scss";

import classNames from "classnames";

import {truncateAccountAddress} from "../../util/walletUtils";
import ClipboardButton from "../../../component/clipboard/button/ClipboardButton";
import {AccountAddressProps} from "./AccountAddress.types";
import Typography from "../../../component/typography/Typography";

function AccountAddress({
  address,
  description,
  nfdomain,
  customClassName,
  withClipboard,
  clipboardColor,
  clipboardCopiedText,
  clipboardPosition = "left"
}: AccountAddressProps) {
  const node = (
    <div className={classNames("is-flex-column account-address", customClassName)}>
      {nfdomain && (
        <Typography
          as={"p"}
          customClassName={"account-address__nfdomain-name"}
          variant={"caption"}
          textColor={"text-gray-lighter"}>
          {nfdomain.name}
        </Typography>
      )}

      <Typography
        as={"p"}
        customClassName={"account-address__address"}
        variant={nfdomain ? "caption" : "body"}
        textColor={nfdomain ? "text-gray-lighter" : "text-main"}>
        {truncateAccountAddress(address)}
      </Typography>

      {!nfdomain && description && (
        <Typography as={"p"} variant={"caption"} textColor={"text-gray-lighter"}>
          {description}
        </Typography>
      )}
    </div>
  );

  return withClipboard ? (
    <ClipboardButton
      textToCopy={address}
      iconPosition={clipboardPosition}
      customClassName={"account-address__clipboard-button"}
      color={clipboardColor || "text-main"}
      aria-label={"Copy account address to clipboard"}
      textCopiedMessage={clipboardCopiedText}
      useMiniIcon={true}>
      {node}
    </ClipboardButton>
  ) : (
    node
  );
}

export default AccountAddress;
